module.exports = __webpack_public_path__ + "img/icon-app-store.4d02174c.png";